import { render, staticRenderFns } from "./QuotationTextsTab.vue?vue&type=template&id=06e1e34d"
import script from "./QuotationTextsTab.vue?vue&type=script&lang=js"
export * from "./QuotationTextsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports